import { types } from 'mobx-state-tree';

export const CaseInfoTaPlanBlockModel = types
  .model('CaseInfoTaPlanBlockModel', {
    caseName: types.maybe(types.string),
    location: types.maybe(types.string)
  })
  .actions(self => ({
    setValues(changedValues) {
      for (let key in changedValues) {
        self[key] = changedValues[key];
      }
    }
  }));
